import { TableRow } from "./table-row.model";

export class TableRowEvent {

    constructor (public row: TableRow, public rowIndex: number) {
    }

}
